<template>
  <div class="movie">
    <el-button type="primary" size="small" icon="el-icon-plus" @click="create">创建</el-button>

    <el-input v-model="key" size="small" style="margin-left: 20px; width: 200px;" placeholder="搜索"></el-input>

    <el-table :data="list" style="width: 100%" class="table">
      <el-table-column label="封面" width="120">
        <template slot-scope="scope">
          <img class="thumb" :src="scope.row.thumb">
        </template>
      </el-table-column>
      <el-table-column prop="name" label="名字" width="180"></el-table-column>
      <el-table-column prop="job" label="职业" width="150"></el-table-column>
      <el-table-column label="代表作" width="250">
        <template slot-scope="scope">
          <span>《{{scope.row.movie}}》</span>
        </template>
      </el-table-column>
      <el-table-column label="图件组件" width="250">
        <template slot-scope="scope">
          <el-button size="small" type="primary" @click="editImageCom(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
      <el-table-column label="显示/隐藏" width="180">
        <template slot-scope="scope">
          <el-switch
            :active-value="0"
            :inactive-value="1"
            v-model="scope.row.is_hidden"
            @change="change($event, scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editItem(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="deleteItem(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pager" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="[5, 10, 15, 20]" :page-size="per_page" layout="total, sizes, prev, pager, next" :total="total">
    </el-pagination>
    <el-dialog :title="action===0?'创建':'编辑'" :visible.sync="dialogVisible" width="1200px">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="名字" prop="name">
          <el-input v-model="form.name" placeholder="名字" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="名字(英文)" prop="name_en">
          <el-input v-model="form.name_en" placeholder="" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="职业" prop="job">
          <el-input v-model="form.job" placeholder="职业" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="职业(英文)" prop="job_en">
          <el-input v-model="form.job_en" placeholder="职业" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="代表作" prop="movie">
          <el-input v-model="form.movie" placeholder="代表作" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="代表作(英文)" prop="movie_en">
          <el-input v-model="form.movie_en" placeholder="代表作" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type" v-if="url==='people'">
          <el-select v-model="form.type" placeholder="请选择">
            <el-option label="艺术家" value="artist"></el-option>
            <el-option label="其他" value=""></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="封面" prop="thumb">
          <img v-if="form.thumb" class="thumb cursor-pointer" :src="form.thumb" title="点击更换" @click="selectThumb">
          <div v-else class="addimg" @click="selectThumb">+</div>
        </el-form-item>
        <el-form-item label="背景" prop="bg">
          <img v-if="form.bg" class="thumb cursor-pointer" :src="form.bg" title="点击更换" @click="selectThumb2">
          <div v-else class="addimg" @click="selectThumb2">+</div>
        </el-form-item>
        <el-form-item label="年份" prop="year">
          <el-input v-model="form.year" placeholder="年份" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="电影数量" prop="movie_total">
          <el-input v-model="form.movie_total" placeholder="电影数量" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="专题数量" prop="topic_total">
          <el-input v-model="form.topic_total" placeholder="专题数量" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="访谈数量" prop="interview_total">
          <el-input v-model="form.interview_total" placeholder="访谈数量" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input type="textarea" :rows="4" v-model="form.description" placeholder="描述" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="描述(英文)" prop="description">
          <el-input type="textarea" :rows="4" v-model="form.description_en" placeholder="描述(英文)" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="电影" prop="movie_ids">
          <el-select multiple v-model="form.movie_ids" placeholder="请选择">
            <el-option :label="item.title" :value="item.id" v-for="item in movies" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="详情">
          <edit-box></edit-box>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button v-show="action===0" type="primary" @click="submit">确 定</el-button>
        <el-button v-show="action===1" type="primary" @click="saveChange">保存更改</el-button>
      </span>
    </el-dialog>

    <!-- 图片组件 -->
    <el-dialog title="编辑图片组件" :visible.sync="imageComVisible" width="1110px">
      <ImageCom v-if="imageComVisible" @save="saveImageCom"  :com="imageCom"></ImageCom>
    </el-dialog>


    <upload-img ref="upload" tips-width="900" tips-height="900"></upload-img>
  </div>
</template>
<script>
import request from '@/utils/request'
import editBox from '../../pages/components/editBox'
import UploadImg from '@/components/UploadImg'

import ImageCom from "@/components/ImageCom"

export default {
  components: {
    editBox,
    UploadImg,
    ImageCom
  },
  props: {
    url: {
      type: String,
      default: 'people'
    }
  },
  data () {
    var validateThumb = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择封面'))
      } else {
        callback()
      }
    }
    return {
      imageCom: [],
      imageComVisible: false,
      movies: [],
      action: 0,
      list: [],
      dialogVisible: false,
      page: 1,
      per_page: 10,
      total: 0,
      current: {},
      key: '',
      form: {
        name: '',
        name_en: '',
        job: '',
        job_en: '',
        movie: '',
        movie_en: '',
        type: '',
        thumb: '',
        bg: '',
        year: '',
        movie_total: '',
        topic_total: '',
        interview_total: '',
        description: '',
        description_en: '',
        movie_ids: [],
        page: {
          style: {
            padding: 0
          },
          modules: []
        }
      },
      rules: {
        name: [
          { required: true, message: '请输入名字', trigger: 'blur' }
        ],
        job: [
          { required: true, message: '请输入职业', trigger: 'blur' }
        ],
        movie: [
          { required: true, message: '请输入代表作', trigger: 'blur' }
        ],
        thumb: [
          { validator: validateThumb, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.getList()
    request({
      url: '/movie'
    }).then(res => {
      this.movies = res.data.list
    })
  },
  watch: {
    key () {
      this.page = 1
      this.getList()
    }
  },
  methods: {
    saveImageCom (val) {
      console.log('保存图片组件', val)

      request({
        url: '/movie/people/' + this.current.uuid,
        method: 'patch',
        data: {
          type: 'update_image_com',
          com: val
        }
      }).then(res => {
        this.$message.success('保存成功!')
        this.imageComVisible = false
        this.getList()
      })

    },
    editImageCom (item) {
      this.imageCom = item.image_com || []
      this.current = item
      this.imageComVisible = true
    },
    getList () {
      request({
        url: '/movie/' + this.url,
        params: {
          per_page: this.per_page,
          page: this.page,
          key: this.key
        }
      }).then(res => {
        this.list = res.data.list
        this.total = res.data.item_total
      })
    },
    handleSizeChange (e) {
      this.per_page = e
      this.handleCurrentChange(1)
    },
    handleCurrentChange (e) {
      this.page = e
      this.getList()
    },
    create () {
      this.action = 0
      this.dialogVisible = true
      this.form = {
        name: '',
        name_en: '',
        job: '',
        job_en: '',
        movie: '',
        movie_en: '',
        type: '',
        thumb: '',
        bg: '',
        year: '',
        movie_total: '',
        topic_total: '',
        interview_total: '',
        description: '',
        description_en: '',
        movie_ids: [],
        page: {
          style: {
            padding: 0
          },
          modules: []
        }
      }
      this.$store.commit('SET_PAGE', this.form.page)
      this.$store.commit('SET_PAGE_CURRENTITEM', '')
    },
    editItem (row) {
      this.current = row
      this.action = 1
      this.dialogVisible = true
      this.form = {
        name: row.name,
        name_en: row.name_en,
        job: row.job,
        job_en: row.job_en,
        movie: row.movie,
        movie_en: row.movie_en,
        type: row.type,
        thumb: row.thumb,
        page: row.page,
        bg: row.bg,
        year: row.year,
        movie_total: row.movie_total,
        topic_total: row.topic_total,
        interview_total: row.interview_total,
        description: row.description,
        description_en: row.description_en,
        movie_ids: row.movie_ids || []
      }
      this.$store.commit('SET_PAGE', this.form.page)
      this.$store.commit('SET_PAGE_CURRENTITEM', '')
      console.log(row)
    },
    selectThumb () {
      let list = []
      if (this.form.thumb) {
        list = [this.form.thumb]
      }
      this.$refs.upload.show(list, 'other', 1).then(res => {
        if (res.length) {
          this.form.thumb = res[0]
        }
      }).catch(_ => {})
    },
    selectThumb2 () {
      let list = []
      if (this.form.bg) {
        list = [this.form.bg]
      }
      this.$refs.upload.show(list, 'other', 1).then(res => {
        if (res.length) {
          this.form.bg = res[0]
        }
      }).catch(_ => {})
    },
    submit () {
      let sendData = JSON.parse(JSON.stringify(this.form))
      if (this.url === 'actors') {
        delete sendData.type
      }
      request({
        url: '/movie/' + this.url,
        method: 'post',
        data: sendData
      }).then(res => {
        this.$message.success('创建成功!')
        this.dialogVisible = false
        this.handleCurrentChange(1)
        this.resetForm()
      })
    },
    saveChange () {
      let sendData = JSON.parse(JSON.stringify(this.form))
      if (this.url === 'actors') {
        delete sendData.type
      }
      request({
        url: '/movie/' + this.url + '/' + this.current.uuid,
        method: 'patch',
        data: {
          type: 'update',
          attributes: sendData
        }
      }).then(res => {
        this.$message.success('保存成功!')
        this.dialogVisible = false
        this.getList()
        this.resetForm()
      })
    },
    resetForm () {
      this.form = {
        title: '',
        time: '',
        type: '',
        thumb: '',
        bg: '',
        year: '',
        movie_total: '',
        topic_total: '',
        interview_total: '',
        description: '',
        movie_ids: [],
        page: {
          style: {
            padding: 0
          },
          modules: []
        }
      }
      this.$refs['form'].resetFields()
    },
    deleteItem (row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/movie/' + this.url + '/' + row.uuid,
          method: 'delete'
        }).then(res => {
          this.$message.success('删除成功!')
          this.getList()
        })
      }).catch()
    },
    change (e, row) {
      request({
        url: '/movie/' + this.url + '/' + row.uuid,
        method: 'patch',
        data: {
          type: e ? 'hide' : 'show'
        }
      }).then(() => {}).catch(() => {
        this.getList()
      })
    }
  }
}
</script>
<style lang="less" scoped>
.table {
  border: 1px solid #ebeef5;
  border-bottom: none;
  margin-top: 10px;
}
.pager {
  margin: 15px 0;
}
.addimg {
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  color: #666;
  font-size: 17px;
  border: 1px dashed #999999;
  cursor: pointer;
}
.thumb {
  height: 50px;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/movie/components/people.vue